import { Modal } from "react-bootstrap";
import { useModemIdHooks } from "../../../utils/inventory/ModemUtils";
import { useEffect, useState } from "react";
import { updateModemDataById } from "../../../api/inventory";
import AlertBox from "../../AlertBox";

export default function ModalEditModem({ show, onClose, id, onSuccess }) {
  const { data, resetData, fetched } = useModemIdHooks({ id });
  const [form, setForm] = useState({
    note: "",
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const handleClose = () => {
    resetData();
    setAlert({ show: false, message: "", type: "" });
    onClose(false);
  };

  useEffect(() => {
    if (fetched) {
      setForm({
        note: data.note || "",
      });
    }
  }, [data.note, fetched]);

  const submitData = (event) => {
    event.preventDefault();
    submitUpdate(form);
  };

  const submitUpdate = async (form) => {
    setLoading(true);
    try {
      let response = await updateModemDataById(id, form);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Modem</Modal.Title>
      </Modal.Header>
      <form onSubmit={(event) => submitData(event)}>
        <Modal.Body>
          <AlertBox {...alert} setAlert={setAlert} />

          <div className="form-group">
            <label>Catatan</label>
            <input
              type="text"
              className="form-control"
              value={form.note}
              onChange={(event) => setForm({ ...form, note: event.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => handleClose()}>
            Close
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            <i className="fas fa-save"></i> {loading ? "Menyimpan ..." : "Simpan Perubahan"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
